export enum AtiraLinkBackgroundImagePosition {
  AUTO = 'auto',
  TOP_LEFT = 'top left',
  TOP_CENTER = 'top center',
  TOP_RIGHT = 'top right',
  CENTER_LEFT = 'center left',
  CENTER = 'center',
  CENTER_RIGHT = 'center right',
  BOTTOM_LEFT = 'bottom left',
  BOTTOM_CENTER = 'bottom center',
  BOTTOM_RIGHT = 'bottom right',
}
